<template>
  <div class="detail" id="detail">
    <div class="row tab" v-if="isTopShow">
      <!-- 顶部 tab 栏 -->
      <div class="col-xs-8 col-sm-9 centre_sm_none" >
        <div class="tab_title">
          <el-tabs v-model="activeName" @tab-click="handleClick" v-if="!isTabShow">
            <el-tab-pane v-for="(item,index) of tabArray" :key="index" :name="item.url" >
              <span slot="label" class="tabContent">
                <i class="el-icon-date"></i>
                {{item.name}}
              </span>
            </el-tab-pane>
          </el-tabs>
          <!-- 数据统计 -->
          <el-tabs v-model="activeName" @tab-click="censusClick" v-else>
            <el-tab-pane v-for="(item,val) of tabTopData" :key="val" :name="item.url" >
              <span slot="label" class="tabContent">
                <i class="el-icon-date"></i>
                {{item.name}}
              </span>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="col-xs-8 col-sm-3 centre_sm_none">
        <div class="tab_right">
          <span class="home-btn" @click="setIndexShow"></span>
        </div>
      </div>
    </div>
    <router-view :flag="flag" :companyIfor="companyIfor" :flag1="flag1"></router-view>
  </div>
</template>

<script>
import {
  companyDetailNews,
  updateEarlyStatus
} from "@/common/js/http/version3Api.js";
import qs from "qs";

export default {
  props: ["powerlist"],
  name: "Detail",
  data() {
    return {
      gridData: [],
      //消息数量
      newsNumber: 0,
      //用户标题
      leftTitle: "Manage",
      restaurants: [],
      val: "",
      state2: "",
      //所有的公司名称
      allCompanyName: [],
      //搜索改变的名称
      newCompanyList: [],
      // 顶部搜索按钮的显示|隐藏
      hiddenSearch: false,
      id: this.$route.query.id,
      activeName: "",
      flag: "CompanyIntroduction",
      flag1: "User",
      // 公司名称
      companyIfor: [],
      valText: "",
      input: "",
      options: [
        {
          value: "选项1",
          label: ""
        },
        {
          value: "选项2",
          label: ""
        }
      ],
      selectVal: "",
      earlyStatus: "0",
      earlId: "",
      tabArray: [],
      resultArray: [],
      managementArray: [],
      messageStatus: false,
      management: false,
      companyId: 1,
      isTopShow: false,
      tabTopData: [],
      isTabShow: false
    };
  },

  created() {
    this.activeName = this.$route.name;

    const menu = JSON.parse(localStorage.getItem("power"));

    if (menu !== null && menu.length > 0) {
      this.tabArray = menu[0].childPermission.filter(item => {
        return item.id !== 8 && item.id !== 17 && item.id !== 20;
      });
      const backArray = menu[0].childPermission.filter(item => {
        if (item.id === 17) {
          this.managementArray = item.childPermission;
          this.management = true;
        } else {
          this.management = false;
        }
      });
      for (var i = 0; i < this.tabArray.length; i++) {
        for (var j = i + 1; j < this.tabArray.length; j++) {
          if (this.tabArray[i].id == this.tabArray[j].id) {
            this.tabArray.splice(j, 1);
            j--;
          }
        }
      }
      this.tabArray.map(item => {
        if (item.url === "CompanyIntroduction") {
          item.name = "Company Profile";
        } else if (item.url === "OverseasEnthusiasm") {
          item.name = "Overseas Public Opinion";
        } else {
          item.name = "Search";
        }
        return item;
      });
      for (var i = 0; i < this.managementArray.length; i++) {
        for (var j = i + 1; j < this.managementArray.length; j++) {
          if (this.managementArray[i].id == this.managementArray[j].id) {
            this.managementArray.splice(j, 1);
            j--;
          }
        }
      }
      const info = menu[0].childPermission.filter(item => {
        return item.id === 8;
      });
      if (info.length) {
        this.messageStatus = true;
      } else {
        this.messageStatus = false;
      }
    } else {
      return;
    }

    if (this.$route.query.num) {
      this.activeName = this.$route.query.num;
      this.flag = "LyricSearch";
    }
    window.addEventListener('setItem', ()=> {
      this.companyId = sessionStorage.getItem('id');
    })
    // this.getearlyWarning();
    // this.getearlyWarningList();
    this.getComapnyDetailNews();
    this.tabTopData.push({
      name: '品牌统计',
      url: 'BrandCensus'
    },{
      name: '品牌热点',
      url: 'NewsCensus'
    })
  },
  mounted() {
    sessionStorage.removeItem("id");
    if(this.$route.path === '/brand/BigFrame/Home') {
      this.isTopShow = false
    }else {
      this.isTopShow = true
    }
  },
  methods: {
    setIndexShow() {
      this.$router.push("/brand/BigFrame/Home");
    },
    //修改消息表格列
    changeStyle(row) {
      if (row.columnIndex === 0) {
        return "cellStyle";
      } else {
        return "";
      }
    },
    //企业详情信息
    async getComapnyDetailNews() {
      let res = await companyDetailNews({ id: this.$route.query.id || 1 });
      this.companyIfor = res.result.list;
      sessionStorage.setItem("id", this.$route.query.id || 1);
    },
    //点击detail
    detailClick(row) {
      this.earlyStatus = 1;
      this.earlId = row.id;
      this.$router.push({
        name: "ArticleDetails",
        query: {
          id: row.newsId
        }
      });
    },
   
    querySwitchVal() {},
    //顶部导航切换
    handleClick(tab, event) {
      this.hiddenSearch = false;
      this.isShowCompanyInfor = true;

      let newflag = tab.name;
      this.activeName = newflag;
      sessionStorage.removeItem('currentPage')
      sessionStorage.removeItem('month')
      switch (newflag) {
        case "CompanyIntroduction":
          this.$router.push({
            path: "/brand/BigFrame/logoDetail/Detail/CompanyIntroduction",
            query: { id: this.$route.query.id }
          });
          break;
        case "OverseasEnthusiasm":
          this.$router.push({
            path: "/brand/BigFrame/logoDetail/Detail/OverseasEnthusiasm",
            query: { id: this.$route.query.id }
          });
          break;
        case "LyricSearch":
          this.$router.push({
            path: "/brand/BigFrame/logoDetail/Detail/LyricSearch",
            query: { id: this.$route.query.id }
          });
          break;
      }
    },
    
    // 顶部导航切换
    censusClick(tab, event) {
      if(tab.name == 'BrandCensus') {
        this.$router.push({
            path: "/brand/BigFrame/logoDetail/Detail/BrandCensus",
          });
      }else {
        this.$router.push({
            path: "/brand/BigFrame/logoDetail/Detail/NewsCensus",
          });
      }
    },
    //用户管理
    handleCommand(command) {
      this.hiddenSearch = true;
      this.isShowCompanyInfor = false;

      switch (true) {
        case command == "User":
          //this.flag1 = "User";
          this.$router.push({
            path: "/brand/BigFrame/logoDetail/Detail/User",
            query: {
              id: this.$route.query.id
            }
          });

          break;
        case command == "Role":
          //this.flag1 = "Role";
          this.$router.push({
            path: "/brand/BigFrame/logoDetail/Detail/Role",
            query: {
              id: this.$route.query.id
            }
          });

          break;
        case command == "Backstage":
          //this.flag1 = "Backstage";
          this.$router.push({
            path: "/brand/BigFrame/logoDetail/Detail/Backstage",
            query: {
              id: this.$route.query.id
            }
          });
          break;
      }
    }
  },
  watch: {
    powerlist: {
      handler(val) {},
      deep: true
    },
    $route: {
      handler(newValue) {
        this.companyId = sessionStorage.getItem("id");
        this.activeName = newValue.name;
        this.getComapnyDetailNews();
        if(newValue.path === '/brand/BigFrame/Home') {
          this.isTopShow = false
        }else {
          this.isTopShow = true
        }
        if(newValue.fullPath === '/brand/BigFrame/logoDetail/Detail/BrandCensus' || newValue.fullPath === '/brand/BigFrame/logoDetail/Detail/NewsCensus') {
          this.isTabShow = true
        }else this.isTabShow = false
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped>
.detail {
  padding: 0 10px;
  height: auto;
  background: #fff;
}

.tab {
  width: 100%;
  height: 65px !important;
  display: flex;
  border-bottom: 1px solid #e4e7ed;
}

.tab .tab_right {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
}

.tab_right .tab_rightCont {
  padding-right: 15px;
}

.hiddenSearch {
  display: none !important;
}

.logonuser {
  right: 300px;
  font-family: Helvetica;
  font-size: 14px;
  color: #4e5671;
  width: 150px;
}

.message_reminder {
  font-family: Helvetica;
  font-size: 14px;
  color: #4e5671;
  margin-right: -22px;
}

.tab_title >>> .el-tabs__item {
  padding: 0 10px !important;
}

.message_reminder >>> .el-table .cell {
  white-space: nowrap;
  overflow: hiddlen;
  text-overflow: ellipsis;
}

.search_company > div {
  display: inline-block;
  vertical-align: middle;
}

.search_txt {
  width: 130px;
  height: 40px;
  margin-left: 10px;
  border-radius: 40px;
  background: #f2f3f4;
  border: 1px solid #e2e3e4;
  overflow: hidden;
  position: relative;
}

.search_input {
  width: 140px;
  height: 100%;
  border-radius: 40px;
  text-indent: 10px;
  position: absolute;
  z-index: 2;
  background: transparent;
}

.home-btn {
  background-image: url(./images/hover@3x.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 20;
  font-size: 28px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: inline-block;
  position: absolute;
  top: 20px;
}

.tab_rightCont >>> .el-table__header-wrapper {
  height: auto !important;
}

.search_txt >>> .el-input--suffix .el-input__inner {
  padding-right: 0;
  color: #000 !important;
}

.search_txt >>> .el_select .el-input__inner {
  border-radius: 0;
  border: 0;
  background-color: transparent;
}

.search_txt >>> .el-input__inner {
  border: 0;
}

.search_txt[data-v-526ae14c] {
  background: #fff;
}

.tab >>> .el-tabs__header {
  border-bottom: 1px solid rgb(235, 233, 233);
  margin-bottom: 0;
}

.tab >>> .el-tabs__header,
.tab >>> .el-tabs__content {
  background: #fff;
  padding: 0 10px;
}

.tab >>> .el-tabs__nav-wrap::after {
  background: 0;
}

.tab >>> .el-tabs__nav .el-tabs__active-bar {
  background: #0078ff;
  /* width: 164px !important; */
}

.tab >>> .el-tabs__nav-wrap .el-tabs__item {
  font-size: 12px;
  color: hsl(235, 11%, 61%);
  font-family: RCR;
}

.tab >>> .el-tabs__nav-wrap {
  height: 65px;
  line-height: 65px;
}

.tab >>> .el-row {
  position: relative;
  top: -65px;
}

.management >>> .el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.management >>> .el-icon-arrow-down {
  font-size: 12px;
}

.management >>> .caret_bottom {
  font-weight: bold;
}

.management >>> .el-dropdown-link {
  font-size: 14px;
  font-weight: bold;
  color: #4e5671;
}

.cellStyle {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.switch_company {
  color: #4e5671;
}

.detail > div {
  height: 100%;
}

.show_data {
  margin-top: 20px;
}

.show_data > div {
  padding: 0 30px;
}

@media screen and (min-width: 1068px) {
  .show_data {
    margin-top: 68px;
  }
  .tab >>> .el-tabs__nav-wrap .el-tabs__item {
    font-size: 14px;
    color: #9092a6;
    font-family: RCR;
  }
  .tab_right .tab_rightCont {
    padding-right: 10px;
  }
}
</style>
<style>
/* 海外舆情 搜索栏 公共样式 */
.condition_search {
  margin-top: 20px;
}

.condition_search .el-date-editor.el-input {
  width: 150px;
}

.condition_search .option {
  margin: 10px 0 8px;
}

.condition_search .option .item_title {
  display: inline-block;
  margin-right: 10px;
  font-family: RCR;
}

.condition_search .el-select {
  width: 150px;
}

.condition_search .el-input__inner,
.condition_search .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.condition_search .el-tag + .el-tag {
  margin-left: 10px;
}

.condition_search .button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.condition_search .input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.el-switch__core {
  width: 48px !important;
  background: #8b939a;
}

.el-switch__label--left,
.el-switch__label--right {
  position: absolute;
  z-index: 1;
  color: #fff;
  user-select: none;
}

.is-checked .el-switch__label--left {
  left: 8px;
  display: block;
}

.is-checked .el-switch__label--right {
  display: none;
}

.el-switch__label--right {
  right: 8px;
  display: block;
}

.el-switch__label--left {
  display: none;
}
</style>